import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

interface QrResponse {
    svg: string;
    png: string;
    qrid: string;
}

@Injectable({providedIn: 'root'})
export class QrGeneratorService {

    constructor(private http: HttpClient) {
    }

    getQrImg(reservation_id) {
        const params = new HttpParams({fromString: 'reservation_id=' + reservation_id});
        return this.http.get<QrResponse>('https://server.ozshuttle.com/api/extras/qr_generator_create.php', {params});
    }

    list() {
        return this.http.get('https://server.ozshuttle.com/api/extras/qr_generator_list.php');
    }

}
